import PettyCashIndex from "@/components/petty-cash/PettyCash.vue";

let routesPettyCash= [
    {
        path: '',
        meta: {
          title: "Chain System",
        },
        name: "Petty Cash",
        component: PettyCashIndex 
    },
      
]

export default routesPettyCash
  